import { Badge } from "@/components/ui/badge";
import { cn } from "@/lib/utils";

const STATUS_CONFIG: Record<string, { label: string; className: string }> = {
  pending: { label: "Na čekanju", className: "bg-yellow-500/10 text-yellow-600 border-yellow-500/20" },
  processing: { label: "U obradi", className: "bg-blue-500/10 text-blue-600 border-blue-500/20" },
  "on-hold": { label: "Na pauzi", className: "bg-orange-500/10 text-orange-600 border-orange-500/20" },
  completed: { label: "Završeno", className: "bg-green-500/10 text-green-600 border-green-500/20" },
  cancelled: { label: "Otkazano", className: "bg-red-500/10 text-red-600 border-red-500/20" },
  refunded: { label: "Refundirano", className: "bg-purple-500/10 text-purple-600 border-purple-500/20" },
  failed: { label: "Neuspjelo", className: "bg-red-500/10 text-red-700 border-red-500/20" },
  trash: { label: "Obrisano", className: "bg-gray-500/10 text-gray-600 border-gray-500/20" },
};

/** Naziv statusa za mjesta gdje badge nosi previše težine (redovi, tooltipovi). */
export function statusLabel(status: string): string {
  return STATUS_CONFIG[status]?.label ?? status;
}

export function StatusBadge({ status }: { status: string }) {
  const config = STATUS_CONFIG[status] || { label: status, className: "" };
  return (
    <Badge variant="outline" className={cn("font-medium", config.className)}>
      {config.label}
    </Badge>
  );
}

// Compact status readout for dense list rows: a colored dot carries the state,
// the label stays in the row's normal text colour so the table keeps its calm greyscale.
const STATUS_DOT: Record<string, string> = {
  pending: "bg-yellow-500",
  processing: "bg-blue-500",
  "on-hold": "bg-orange-500",
  completed: "bg-green-500",
  cancelled: "bg-red-500",
  refunded: "bg-purple-500",
  failed: "bg-red-600",
  trash: "bg-gray-400",
};

export function statusDotClass(status: string) {
  return STATUS_DOT[status] || "bg-muted-foreground";
}

export function StatusDot({ status }: { status: string }) {
  const config = STATUS_CONFIG[status];
  return (
    <span className="inline-flex items-center gap-1.5 whitespace-nowrap">
      <span className={cn("h-1.5 w-1.5 shrink-0 rounded-full", statusDotClass(status))} />
      <span className="font-medium">{config?.label ?? status}</span>
    </span>
  );
}

export const ORDER_STATUSES = [
  { value: "", label: "Sve" },
  { value: "pending", label: "Na čekanju" },
  { value: "processing", label: "U obradi" },
  { value: "on-hold", label: "Na pauzi" },
  { value: "completed", label: "Završeno" },
  { value: "cancelled", label: "Otkazano" },
  { value: "refunded", label: "Refundirano" },
  { value: "failed", label: "Neuspjelo" },
];
